import React from "react";
import "./MyProjects.css";
import { FaGithub, FaLink } from "react-icons/fa";
import dealsOfTheDayIcon from "../../Assets/Project_Icon/dealsOfTheDay.png";
import cseFromHomeIcon from "../../Assets/Project_Icon/cse_from_home.png";
import deshiVibesIcon from "../../Assets/Project_Icon/DeshiVibes.png";
import myBlogIcon from "../../Assets/Project_Icon/MyBlog.png";
import toDoAppIcon from "../../Assets/Project_Icon/to-do-app.png";
import cleanSmileIcon from "../../Assets/Project_Icon/clean-smile.png";

const MyProjects = () => {
  return (
    <div id="myProjects" className="lg:pt-40 md:pt-40 pt-8">
      <div className="lg:w-[65%] md:w-[85%] mx-auto lg:px-0 md:px-0 sm:px-8 px-4">
        <div className="">
          <h4 className="text-blue text-lg font-poppins font-bold">
            MY PROJECTS
          </h4>
          <p className="font-poppins font-bold lg:text-xl md:text-xl mb-10">
            Each project is unique piece of development. 💎
          </p>
        </div>
        <div className="projects-section lg:flex md:flex flex-col gap-y-6 sm:hidden hidden">
          {/* Deshi Vibes Start */}
          <div className="bg-white project-case p-4 rounded-lg flex lg:flex-row md:flex-row flex-col gap-x-16 gap-y-8 project-card">
            <div className="content lg:w-[55%] md:w-[55%]">
              <div className="screen">
                <img
                  className="hover:-top-[1600px]"
                  src="https://res.cloudinary.com/dou96vwyp/image/upload/v1703477024/cse-from-home-projects-assests/Deshi_Vibes.png"
                  alt=""
                />
              </div>
            </div>
            <div className="lg:w-[45%] md:w-[45%] flex flex-col gap-y-6 justify-center">
              <div className="flex flex-col gap-y-2">
                <div className="flex items-center justify-center gap-x-2">
                  <h3 className="font-poppins text-lg font-semibold">
                    Deshi Vibes
                  </h3>
                  <img
                    className="w-6"
                    src={deshiVibesIcon}
                    alt="shopping icon"
                  />
                </div>
                <p className="text-center font-poppins font-medium text-gray-light">
                  An e-commerce fashion products selling website where the admin
                  can upload various categories of products for sale. Customers
                  can buy products by paying via SSL Commerz. Admin can ship the
                  order or cancel the order.
                </p>
              </div>
              <div className="grid grid-cols-4 gap-2 text-center text-sm">
                <span className="py-1 project-case font-mulish font-semibold">
                  Tailwind
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  React
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Redux
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Node.js
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Express.js
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  MongoDB
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Firebase
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  SSL Commerz
                </span>
              </div>
              <div className="flex justify-center gap-x-8">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://github.com/khubaibul/deshi-vibes-client-site"
                  className="flex items-center gap-x-1"
                >
                  <h3 className="font-poppins font-semibold">Code</h3>
                  <FaGithub className="text-xl" />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://deshi-vibes.web.app"
                  className="flex items-center gap-x-1"
                >
                  <h3 className="font-poppins font-semibold">Live</h3>
                  <FaLink className="text-xl" />
                </a>
              </div>
            </div>
          </div>
          {/* Deshi Vibes End */}

          {/* CSE From Home Start */}
          <div className="bg-white project-case p-4 rounded-lg flex lg:flex-row-reverse md:flex-row-reverse flex-col gap-x-16 gap-y-8 project-card">
            <div className="content lg:w-[55%] md:w-[55&]">
              <div className="screen">
                <img
                  className="hover:-top-[1635px]"
                  src="https://res.cloudinary.com/dou96vwyp/image/upload/v1706029670/cse-from-home-projects-assests/cse-from-home-app.png"
                  alt=""
                />
              </div>
            </div>
            <div className="lg:w-[45%] md:w-[45%] flex flex-col gap-y-6 justify-center">
              <div className="flex flex-col gap-y-2">
                <div className="flex items-center justify-center gap-x-2">
                  <h3 className="font-poppins text-lg font-semibold">
                    CSE From Home
                  </h3>
                  <img
                    className="w-6"
                    src={cseFromHomeIcon}
                    alt="CSE From Home Icon"
                  />
                </div>
                <p className="text-center font-poppins font-medium text-gray-light">
                  An ed-tech online platform for CSE-related courses. Students
                  can see course's tentative outline and also can download the
                  outline as a PDF. By clicking the Courses button he can
                  navigate there. To get premium content access, users must use
                  SSL-Commerz to pay. Students can see course content in my
                  class section. Admin can track all courses content and also
                  students progress.
                </p>
              </div>
              <div className="grid grid-cols-4 gap-2 text-center text-sm">
                <span className="py-1 project-case font-mulish font-semibold">
                  Tailwind
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  React
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Node.js
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Express.js
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  MongoDB
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Firebase
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Cloudinary
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  SSL-Commerz
                </span>
              </div>
              <div className="flex justify-center gap-x-8">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://github.com/khubaibul/learning-platform-client"
                  className="flex items-center gap-x-1"
                >
                  <h3 className="font-poppins font-semibold">Code</h3>
                  <FaGithub className="text-xl" />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://cse-from-home-app.web.app/home"
                  className="flex items-center gap-x-1"
                >
                  <h3 className="font-poppins font-semibold">Live</h3>
                  <FaLink className="text-xl" />
                </a>
              </div>
            </div>
          </div>
          {/* CSE From Home End */}

          {/* Deals of The Day Start */}
          <div className="bg-white project-case p-4 rounded-lg flex lg:flex-row-reverse md:flex-row-reverse flex-col gap-x-16 gap-y-8 project-card">
            <div className="lg:w-[45%] md:w-[45%] flex flex-col gap-y-6 justify-center">
              <div className="flex flex-col gap-y-2">
                <div className="flex items-center justify-center gap-x-2">
                  <h3 className="font-poppins text-lg font-semibold">
                    Deals of The Day
                  </h3>
                  <img
                    className="w-6"
                    src={dealsOfTheDayIcon}
                    alt="shopping icon"
                  />
                </div>
                <p className="text-center font-poppins font-medium text-gray-light">
                  An e-commerce multi-vendor shopping website where a seller can
                  post products for sale. Customers can see the details of the
                  product and can buy by paying via Stripe. Difference dashboard
                  for customer, seller and admin.
                </p>
              </div>
              <div className="grid grid-cols-4 gap-2 text-center text-sm">
                <span className="py-1 project-case font-mulish font-semibold">
                  Tailwind
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  React
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Node.js
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Express.js
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  MongoDB
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Firebase
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  JWT
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Stripe
                </span>
              </div>
              <div className="flex justify-center gap-x-8">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://github.com/khubaibul/deals-of-the-day-client-site-repo"
                  className="flex items-center gap-x-1"
                >
                  <h3 className="font-poppins font-semibold">Code</h3>
                  <FaGithub className="text-xl" />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://deals-of-the-day-61353.web.app"
                  className="flex items-center gap-x-1"
                >
                  <h3 className="font-poppins font-semibold">Live</h3>
                  <FaLink className="text-xl" />
                </a>
              </div>
            </div>
            <div className="content lg:w-[55%] md:w-[55&]">
              <div className="screen">
                <img
                  className="hover:-top-[945px]"
                  src="https://res.cloudinary.com/dou96vwyp/image/upload/v1727806904/cse-from-home-projects-assests/deals_of_the_day_r6ly2p.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          {/* Deals of The Day End */}

          {/* My Blog Start */}
          <div className="bg-white project-case p-4 rounded-lg flex lg:flex-row md:flex-row flex-col gap-x-16 gap-y-8 project-card">
            <div className="lg:w-[45%] md:w-[45%] flex flex-col gap-y-9 justify-center">
              <div className="flex flex-col gap-y-2">
                <div className="flex items-center justify-center gap-x-2">
                  <h3 className="font-poppins text-lg font-semibold">
                    My Blogs
                  </h3>
                  <img className="w-6" src={myBlogIcon} alt="shopping icon" />
                </div>
                <p className="text-center font-poppins font-medium text-gray-light">
                  A blogging website using Next.js where I post about tech
                  stack. Users can read my blog. Also can comment on the post.
                  To write a comment they need to signup or login by using Next
                  Auth.
                </p>
              </div>
              <div className="grid grid-cols-4 gap-2 text-center text-sm">
                <span className="py-1 project-case font-mulish font-semibold">
                  Tailwind
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  TypeScript
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Next.js
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Next Auth
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Sanity CMS
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Vercel
                </span>
              </div>
              <div className="flex justify-center gap-x-8">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://github.com/khubaibul/my-blog"
                  className="flex items-center gap-x-1"
                >
                  <h3 className="font-poppins font-semibold">Code</h3>
                  <FaGithub className="text-xl" />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://my-blog-kishakib.vercel.app"
                  className="flex items-center gap-x-1"
                >
                  <h3 className="font-poppins font-semibold">Live</h3>
                  <FaLink className="text-xl" />
                </a>
              </div>
            </div>
            <div className="content lg:w-[55%] md:w-[55%]">
              <div className="screen">
                <img
                  className="hover:-top-[520px]"
                  src="https://res.cloudinary.com/dou96vwyp/image/upload/v1703477023/cse-from-home-projects-assests/My_Blog.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          {/* My Blog End */}

          {/* Clean Smile Start */}
          <div className="bg-white project-case p-4 rounded-lg flex lg:flex-row-reverse md:flex-row-reverse flex-col gap-x-16 gap-y-8 project-card">
            <div className="lg:w-[45%] md:w-[45%] flex flex-col gap-y-6 justify-center">
              <div className="flex flex-col gap-y-2">
                <div className="flex items-center justify-center gap-x-2">
                  <h3 className="font-poppins text-lg font-semibold">
                    Clean Smile
                  </h3>
                  <img
                    className="w-6"
                    src={cleanSmileIcon}
                    alt="shopping icon"
                  />
                </div>
                <p className="text-center font-poppins font-medium text-gray-light">
                  A dentist website where patient can book their appointment
                  with the doctor. They can select schedule from available slot.
                  After selecting their slot they have book the slot by using
                  Stripe payment system.
                </p>
              </div>
              <div className="grid grid-cols-4 gap-2 text-center text-sm">
                <span className="py-1 project-case font-mulish font-semibold">
                  Tailwind
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  React
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Node.js
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Express.js
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  MongoDB
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Firebase
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  JWT
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Stripe
                </span>
              </div>
              <div className="flex justify-center gap-x-8">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://github.com/khubaibul/clean-smile"
                  className="flex items-center gap-x-1"
                >
                  <h3 className="font-poppins font-semibold">Code</h3>
                  <FaGithub className="text-xl" />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://clean-smile-dental-care.web.app"
                  className="flex items-center gap-x-1"
                >
                  <h3 className="font-poppins font-semibold">Live</h3>
                  <FaLink className="text-xl" />
                </a>
              </div>
            </div>
            <div className="content lg:w-[55%] md:w-[55%]">
              <div className="screen">
                <img
                  className="hover:-top-[1220px]"
                  src="https://res.cloudinary.com/dou96vwyp/image/upload/v1703477025/cse-from-home-projects-assests/Clean_Smile.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          {/* Clean Smile End */}

          {/* TO-DO App Start */}
          <div className="bg-white project-case p-4 rounded-lg flex lg:flex-row md:flex-row flex-col gap-x-16 gap-y-8 project-card">
            <div className="lg:w-[45%] md:w-[45%] flex flex-col gap-y-8 justify-center">
              <div className="flex flex-col gap-y-2">
                <div className="flex items-center justify-center gap-x-2">
                  <h3 className="font-poppins text-lg font-semibold">
                    TO-DO App
                  </h3>
                  <img className="w-6" src={toDoAppIcon} alt="shopping icon" />
                </div>
                <p className="text-center font-poppins font-medium text-gray-light">
                  A TO-Do list app. Where a user can add to list his/her daily
                  task. Users can drag & drop a task. Also, the user can delete
                  all completed tasks. Users also can filter the task by
                  all/complete/active. There is also a toggle button for dark
                  and light theme toggling.
                </p>
              </div>
              <div className="grid grid-cols-4 gap-2 text-center text-sm">
                <span className="py-1 project-case font-mulish font-semibold">
                  HTML5
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  CSS3
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  JavaScript
                </span>
              </div>
              <div className="flex justify-center gap-x-8">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://github.com/khubaibul/todo-app"
                  className="flex items-center gap-x-1"
                >
                  <h3 className="font-poppins font-semibold">Code</h3>
                  <FaGithub className="text-xl" />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://khubaibul.github.io/todo-app"
                  className="flex items-center gap-x-1"
                >
                  <h3 className="font-poppins font-semibold">Live</h3>
                  <FaLink className="text-xl" />
                </a>
              </div>
            </div>
            <div className="content lg:w-[55%] md:w-[55%]">
              <div className="screen">
                <img
                  className="hover:-top-[10px]"
                  src="https://res.cloudinary.com/dou96vwyp/image/upload/v1703477021/cse-from-home-projects-assests/To_Do_App.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          {/* TO-DO App End */}
        </div>
        <div className="projects-section flex sm:flex flex-col gap-y-6 lg:hidden md:hidden">
          {/* Deshi Vibes Start */}
          <div className="bg-white project-case p-4 rounded-lg flex lg:flex-row md:flex-row flex-col gap-x-16 gap-y-8">
            <div className="content lg:w-[55%] md:w-[55%]">
              <div className="screen">
                <img
                  className="hover:-top-[1600px]"
                  src="https://res.cloudinary.com/dou96vwyp/image/upload/v1703477024/cse-from-home-projects-assests/Deshi_Vibes.png"
                  alt=""
                />
              </div>
            </div>
            <div className="lg:w-[45%] md:w-[45%] flex flex-col gap-y-6 justify-center">
              <div className="flex flex-col gap-y-2">
                <div className="flex items-center justify-center gap-x-2">
                  <h3 className="font-poppins text-lg font-semibold">
                    Deshi Vibes
                  </h3>
                  <img
                    className="w-6"
                    src={deshiVibesIcon}
                    alt="shopping icon"
                  />
                </div>
                <p className="text-center font-poppins font-medium text-gray-light">
                  An e-commerce fashion products selling website where the admin
                  can upload various categories of products for sale. Customers
                  can buy products by paying via SSL Commerz. Admin can ship the
                  order or cancel the order.
                </p>
              </div>
              <div className="grid grid-cols-4 gap-2 text-center text-sm">
                <span className="py-1 project-case font-mulish font-semibold">
                  Tailwind
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  React
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Redux
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Node.js
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Express.js
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  MongoDB
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Firebase
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  SSL Commerz
                </span>
              </div>
              <div className="flex justify-center gap-x-8">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://github.com/khubaibul/deshi-vibes-client-site"
                  className="flex items-center gap-x-1"
                >
                  <h3 className="font-poppins font-semibold">Code</h3>
                  <FaGithub className="text-xl" />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://deshi-vibes.web.app"
                  className="flex items-center gap-x-1"
                >
                  <h3 className="font-poppins font-semibold">Live</h3>
                  <FaLink className="text-xl" />
                </a>
              </div>
            </div>
          </div>
          {/* Deshi Vibes End */}

          {/* CSE From Home Start */}
          <div className="bg-white project-case p-4 rounded-lg flex lg:flex-row-reverse md:flex-row-reverse flex-col gap-x-16 gap-y-8">
            <div className="content lg:w-[55%] md:w-[55&]">
              <div className="screen">
                <img
                  className="hover:-top-[945px]"
                  src="https://res.cloudinary.com/dou96vwyp/image/upload/v1706029670/cse-from-home-projects-assests/cse-from-home-app.png"
                  alt=""
                />
              </div>
            </div>
            <div className="lg:w-[45%] md:w-[45%] flex flex-col gap-y-6 justify-center">
              <div className="flex flex-col gap-y-2">
                <div className="flex items-center justify-center gap-x-2">
                  <h3 className="font-poppins text-lg font-semibold">
                    CSE From Home
                  </h3>
                  <img
                    className="w-6"
                    src={cseFromHomeIcon}
                    alt="CSE From Home Icon"
                  />
                </div>
                <p className="text-center font-poppins font-medium text-gray-light">
                  An ed-tech online platform for CSE-related courses. Students
                  can see course's tentative outline and also can download the
                  outline as a PDF. By clicking the Courses button he can
                  navigate there. To get premium content access, users must use
                  SSL-Commerz to pay. Students can see course content in my
                  class section. Admin can track all courses content and also
                  students progress.
                </p>
              </div>
              <div className="grid grid-cols-4 gap-2 text-center text-sm">
                <span className="py-1 project-case font-mulish font-semibold">
                  Tailwind
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  React
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Node.js
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Express.js
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  MongoDB
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Firebase
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Cloudinary
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  SSL-Commerz
                </span>
              </div>
              <div className="flex justify-center gap-x-8">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://github.com/khubaibul/learning-platform-client"
                  className="flex items-center gap-x-1"
                >
                  <h3 className="font-poppins font-semibold">Code</h3>
                  <FaGithub className="text-xl" />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://cse-from-home-app.web.app/home"
                  className="flex items-center gap-x-1"
                >
                  <h3 className="font-poppins font-semibold">Live</h3>
                  <FaLink className="text-xl" />
                </a>
              </div>
            </div>
          </div>
          {/* Deals of The Day End */}
          {/* Deals of The Day Start */}
          <div className="bg-white project-case p-4 rounded-lg flex lg:flex-row-reverse md:flex-row-reverse flex-col gap-x-16 gap-y-8">
            <div className="content lg:w-[55%] md:w-[55&]">
              <div className="screen">
                <img
                  className="hover:-top-[945px]"
                  src="https://res.cloudinary.com/dou96vwyp/image/upload/v1703477027/cse-from-home-projects-assests/deals_of_the_day.png"
                  alt=""
                />
              </div>
            </div>
            <div className="lg:w-[45%] md:w-[45%] flex flex-col gap-y-6 justify-center">
              <div className="flex flex-col gap-y-2">
                <div className="flex items-center justify-center gap-x-2">
                  <h3 className="font-poppins text-lg font-semibold">
                    Deals of The Day
                  </h3>
                  <img
                    className="w-6"
                    src={dealsOfTheDayIcon}
                    alt="shopping icon"
                  />
                </div>
                <p className="text-center font-poppins font-medium text-gray-light">
                  An e-commerce multi-vendor shopping website where a seller can
                  post products for sale. Customers can see the details of the
                  product and can buy by paying via Stripe. Difference dashboard
                  for customer, seller and admin.
                </p>
              </div>
              <div className="grid grid-cols-4 gap-2 text-center text-sm">
                <span className="py-1 project-case font-mulish font-semibold">
                  Tailwind
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  React
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Node.js
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Express.js
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  MongoDB
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Firebase
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  JWT
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Stripe
                </span>
              </div>
              <div className="flex justify-center gap-x-8">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://github.com/khubaibul/deals-of-the-day-client-site-repo"
                  className="flex items-center gap-x-1"
                >
                  <h3 className="font-poppins font-semibold">Code</h3>
                  <FaGithub className="text-xl" />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://deals-of-the-day-61353.web.app"
                  className="flex items-center gap-x-1"
                >
                  <h3 className="font-poppins font-semibold">Live</h3>
                  <FaLink className="text-xl" />
                </a>
              </div>
            </div>
          </div>
          {/* Deals of The Day End */}

          {/* My Blog Start */}
          <div className="bg-white project-case p-4 rounded-lg flex lg:flex-row md:flex-row flex-col gap-x-16 gap-y-8">
            <div className="content lg:w-[55%] md:w-[55%]">
              <div className="screen">
                <img
                  className="hover:-top-[520px]"
                  src="https://res.cloudinary.com/dou96vwyp/image/upload/v1703477023/cse-from-home-projects-assests/My_Blog.png"
                  alt=""
                />
              </div>
            </div>
            <div className="lg:w-[45%] md:w-[45%] flex flex-col gap-y-9 justify-center">
              <div className="flex flex-col gap-y-2">
                <div className="flex items-center justify-center gap-x-2">
                  <h3 className="font-poppins text-lg font-semibold">
                    My Blogs
                  </h3>
                  <img className="w-6" src={myBlogIcon} alt="shopping icon" />
                </div>
                <p className="text-center font-poppins font-medium text-gray-light">
                  A blogging website using Next.js where I post about tech
                  stack. Users can read my blog. Also can comment on the post.
                  To write a comment they need to signup or login by using Next
                  Auth.
                </p>
              </div>
              <div className="grid grid-cols-4 gap-2 text-center text-sm">
                <span className="py-1 project-case font-mulish font-semibold">
                  Tailwind
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  TypeScript
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Next.js
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Next Auth
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Sanity CMS
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Vercel
                </span>
              </div>
              <div className="flex justify-center gap-x-8">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://github.com/khubaibul/my-blog"
                  className="flex items-center gap-x-1"
                >
                  <h3 className="font-poppins font-semibold">Code</h3>
                  <FaGithub className="text-xl" />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://my-blog-kishakib.vercel.app"
                  className="flex items-center gap-x-1"
                >
                  <h3 className="font-poppins font-semibold">Live</h3>
                  <FaLink className="text-xl" />
                </a>
              </div>
            </div>
          </div>
          {/* My Blog End */}

          {/* Clean Smile Start */}
          <div className="bg-white project-case p-4 rounded-lg flex lg:flex-row-reverse md:flex-row-reverse flex-col gap-x-16 gap-y-8">
            <div className="content lg:w-[55%] md:w-[55%]">
              <div className="screen">
                <img
                  className="hover:-top-[1220px]"
                  src="https://res.cloudinary.com/dou96vwyp/image/upload/v1703477025/cse-from-home-projects-assests/Clean_Smile.png"
                  alt=""
                />
              </div>
            </div>
            <div className="lg:w-[45%] md:w-[45%] flex flex-col gap-y-6 justify-center">
              <div className="flex flex-col gap-y-2">
                <div className="flex items-center justify-center gap-x-2">
                  <h3 className="font-poppins text-lg font-semibold">
                    Clean Smile
                  </h3>
                  <img
                    className="w-6"
                    src={cleanSmileIcon}
                    alt="shopping icon"
                  />
                </div>
                <p className="text-center font-poppins font-medium text-gray-light">
                  A dentist website where patient can book their appointment
                  with the doctor. They can select schedule from available slot.
                  After selecting their slot they have book the slot by using
                  Stripe payment system.
                </p>
              </div>
              <div className="grid grid-cols-4 gap-2 text-center text-sm">
                <span className="py-1 project-case font-mulish font-semibold">
                  Tailwind
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  React
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Node.js
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Express.js
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  MongoDB
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Firebase
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  JWT
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  Stripe
                </span>
              </div>
              <div className="flex justify-center gap-x-8">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://github.com/khubaibul/clean-smile"
                  className="flex items-center gap-x-1"
                >
                  <h3 className="font-poppins font-semibold">Code</h3>
                  <FaGithub className="text-xl" />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://clean-smile-dental-care.web.app"
                  className="flex items-center gap-x-1"
                >
                  <h3 className="font-poppins font-semibold">Live</h3>
                  <FaLink className="text-xl" />
                </a>
              </div>
            </div>
          </div>
          {/* Clean Smile End */}

          {/* TO-DO App Start */}
          <div className="bg-white project-case p-4 rounded-lg flex lg:flex-row md:flex-row flex-col gap-x-16 gap-y-8">
            <div className="content lg:w-[55%] md:w-[55%]">
              <div className="screen">
                <img
                  className="hover:-top-[10px]"
                  src="https://res.cloudinary.com/dou96vwyp/image/upload/v1703477021/cse-from-home-projects-assests/To_Do_App.png"
                  alt=""
                />
              </div>
            </div>
            <div className="lg:w-[45%] md:w-[45%] flex flex-col gap-y-8 justify-center">
              <div className="flex flex-col gap-y-2">
                <div className="flex items-center justify-center gap-x-2">
                  <h3 className="font-poppins text-lg font-semibold">
                    TO-DO App
                  </h3>
                  <img className="w-6" src={toDoAppIcon} alt="shopping icon" />
                </div>
                <p className="text-center font-poppins font-medium text-gray-light">
                  A TO-Do list app. Where a user can add to list his/her daily
                  task. Users can drag & drop a task. Also, the user can delete
                  all completed tasks. Users also can filter the task by
                  all/complete/active. There is also a toggle button for dark
                  and light theme toggling.
                </p>
              </div>
              <div className="grid grid-cols-4 gap-2 text-center text-sm">
                <span className="py-1 project-case font-mulish font-semibold">
                  HTML5
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  CSS3
                </span>
                <span className="py-1 project-case font-mulish font-semibold">
                  JavaScript
                </span>
              </div>
              <div className="flex justify-center gap-x-8">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://github.com/khubaibul/todo-app"
                  className="flex items-center gap-x-1"
                >
                  <h3 className="font-poppins font-semibold">Code</h3>
                  <FaGithub className="text-xl" />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://khubaibul.github.io/todo-app"
                  className="flex items-center gap-x-1"
                >
                  <h3 className="font-poppins font-semibold">Live</h3>
                  <FaLink className="text-xl" />
                </a>
              </div>
            </div>
          </div>
          {/* TO-DO App End */}
        </div>
      </div>
    </div>
  );
};

export default MyProjects;
